var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",attrs:{"width":_vm.width * 50,"height":_vm.height * 50}})}
var staticRenderFns = []

export { render, staticRenderFns }